module.exports = __webpack_public_path__ + "img/maps_livre.c8586417.svg";